// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__18NvM","consentsList":"PatientConsents_consentsList__1X2fp","consentsListEmpty":"PatientConsents_consentsListEmpty__iVrAj"};